module.exports = __webpack_public_path__ + "static/media/carousel-cgc-website-09_b-1.905e8b75.png";